import { httpClient } from "../../utils/HttpClient";

import {
    HTTP_ROOM_FETCHING,
    HTTP_ROOM_SUCCESS,
    HTTP_ROOM_FAILED
  } from "../../constants/other";

import {
  server
} from "../../constants";

const setStateRoomsToSuccess = (payload) => ({
  type: HTTP_ROOM_SUCCESS,
  payload: payload,
});

const setStateRoomsFetching = () => ({
  type: HTTP_ROOM_FETCHING,
});

const setStateRoomsToFailed = () => ({
  type: HTTP_ROOM_FAILED,
});


export const getAllRooms = (page) => {
  return async (dispatch) => {
    dispatch(setStateRoomsFetching());
    await doGetRooms(dispatch,page);
  };
};

const doGetRooms = async (dispatch,page) => {
    try {
      const result = await httpClient.get(server.ROOM_URL, { 
        params: {
          page: page
        }
      })
      dispatch(setStateRoomsToSuccess(result.data));
    } catch(err)  {
      console.log(err);
      dispatch(setStateRoomsToFailed());
    }
};


export const deleteRoom = (id) => {
  return async (dispatch) => {
    dispatch(setStateRoomsFetching());
    const response = await httpClient.delete(
      server.ROOM_URL + "/" + `${id}`
    );
    if (response.status === 201 || response.status === 200) {
      alert('Delete Complete')
      await doGetRooms(dispatch);
    }
  };
};
